import { usePathParam, useQueryParam } from 'react-resource-router';

import { useResource } from '@atlassian/eoc-rrr-helpers';

import { QUERY_PARAMS } from '../../common/constants';
import { type Space } from '../../common/types';
import { opsReportsPermissionResource, opsReportsResource } from '../../services/resources';

export const useReportsController = () => {
	const [teamId] = usePathParam('teamId');
	const [dashboardId] = usePathParam('dashboardId');
	const [selectedTeamId] = useQueryParam(QUERY_PARAMS.SELECTED_TEAM_ID);
	const [global] = useQueryParam(QUERY_PARAMS.GLOBAL);
	const isGlobal = global === 'true';

	const permissionResource = useResource(opsReportsPermissionResource);
	const reportsResource = useResource(opsReportsResource);
	const isLoading = permissionResource.loading || reportsResource.loading;
	const error = permissionResource.error || reportsResource.error;
	let hideItemsInSidebar: boolean = false;
	let navigationItems: Space[] = [];

	if (reportsResource.data) {
		const { settings, dashboards } = reportsResource.data;

		navigationItems = (isGlobal ? dashboards?.globalSpaces : dashboards?.teamSpaces) || [];
		hideItemsInSidebar = Boolean(settings?.showReportingMaintenance) || !navigationItems.length;
	}

	return {
		teamId: selectedTeamId || teamId,
		dashboardId,
		error,
		navigationItems,
		isGlobal,
		hideItemsInSidebar,
		isLoading,
	};
};
